import { createFileRoute } from '@tanstack/react-router'
import KohBusPaymentConfirmed from '@/components/make-booking/payment/PaymentConfirmed'

export const Route = createFileRoute('/make-booking/$id/payment/confirmed')({
  component: RouteComponent,
})

function RouteComponent() {
  return <KohBusPaymentConfirmed />
}
